export default __webpack_public_path__ + "static/media/SWT0190.34I-27413_-16475_0.f54e9c83.jpg";